/**
 * Represents the remark/merknad flags for a product (NV03 - VAVE).
 * Each flag is stored as a single character.
 */
export enum ProductRemarkFlags {
  /** 1 = UTGÅR */
  FLAG_1 = '1 UTGÅR',

  /** X = UTGÅR KAMPANJEVARE */
  FLAG_X = 'X UTGÅR KAMPANJEVARE',

  /** 2 = PÅ BESTILLING */
  FLAG_2 = '2 PÅ BESTILLING',

  /** 3 = AVSKREVET */
  FLAG_3 = '3 AVSKREVET',

  /** 4 = ALT.ART. / OVERFØRINGSNR. */
  FLAG_4 = '4 ALT.ART. / OVERFØRINGSNR.',

  /** 5 = IKKE I PRISLISTE */
  FLAG_5 = '5 IKKE I PRISLISTE',

  /** 6 = MÅ BESTILLES */
  FLAG_6 = '6 MÅ BESTILLES',

  /** 7 = IKKE LAGERSTYRING */
  FLAG_7 = '7 IKKE LAGERSTYRING',

  /** 8 = UNDER TELLING */
  FLAG_8 = '8 UNDER TELLING',

  /** T = TILBUDSPRIS */
  FLAG_T = 'T TILBUDSPRIS',

  /** E = HYLLE - ETTIKETTE */
  FLAG_E = 'E HYLLE - ETTIKETTE',

  /** F = IKKE MED I FAKTURABONUSGRUNNLAG */
  FLAG_F = 'F IKKE MED I FAKTURABONUSGRUNNLAG',
}
